import {
  TRIGGER_DIAGRAMS_INTERPRET_REQUEST,
  TRIGGER_DIAGRAMS_INTERPRET_SUCCESS,
  TRIGGER_DIAGRAMS_INTERPRET_FAILURE,
  TRIGGER_DIAGRAMS_RENDER_REQUEST,
  TRIGGER_DIAGRAMS_RENDER_SUCCESS,
  TRIGGER_DIAGRAMS_RENDER_FAILURE,
  RESET_DIAGRAMS_STATE,
} from "../actions/diagramsAgentActions";

const initialState = {
  interpretStatus: "idle", // idle | submitting | success | error
  renderStatus: "idle",
  lastRunId: null,
  lastTopic: null,
  lastRepos: null,
  lastDirection: null,
  lastLineStyle: null,
  error: null,
};

const diagramsAgentReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRIGGER_DIAGRAMS_INTERPRET_REQUEST:
      return {
        ...state,
        interpretStatus: "submitting",
        renderStatus: "idle",
        lastRunId: action.payload?.runId || null,
        lastTopic: action.payload?.topic || null,
        lastRepos: action.payload?.repos || null,
        lastDirection: action.payload?.direction || null,
        lastLineStyle: action.payload?.lineStyle || null,
        error: null,
      };
    case TRIGGER_DIAGRAMS_INTERPRET_SUCCESS:
      return { ...state, interpretStatus: "success", error: null };
    case TRIGGER_DIAGRAMS_INTERPRET_FAILURE:
      return { ...state, interpretStatus: "error", error: action.error };

    case TRIGGER_DIAGRAMS_RENDER_REQUEST:
      return {
        ...state,
        renderStatus: "submitting",
        error: null,
      };
    case TRIGGER_DIAGRAMS_RENDER_SUCCESS:
      return { ...state, renderStatus: "success", error: null };
    case TRIGGER_DIAGRAMS_RENDER_FAILURE:
      return { ...state, renderStatus: "error", error: action.error };

    case RESET_DIAGRAMS_STATE:
      return initialState;

    default:
      return state;
  }
};

export default diagramsAgentReducer;
